import prefix from './prefix';

export const WEBSOCKET_SUBSCRIBED = prefix('WEBSOCKET_SUBSCRIBED');
export const WEBSOCKET_UNSUBSCRIBED = prefix('WEBSOCKET_UNSUBSCRIBED');
